import React, { Fragment, useState, useEffect } from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { FaTrash, FaTimes, FaCheck } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { MainBlock } from "../../Buttons";
import { Divs } from "../../StyledComponents";
import TextInputModal from "../../TextInputModal";
import OrderRowAdd from "./editModal/order_row/order_row_add";
import RenderDelivery from "./OrderCreateModal/RenderDelivery";
import RenderStatus from "./OrderCreateModal/RenderStatus";
import { createOrder } from "../../../../redux/Actions/orderAction";
import OrderTotalComponent from "./editModal/SmallComp/order_total";
import {
  getFromPercentage,
  phonenumberValid,
  validateEmail,
} from "../../../../helpers/Utils";
import { unsuccessToast } from "../../../../helpers/ErrorsToasts";
import { useDispatch, useSelector } from "react-redux";
import RenderAddress from "./OrderCreateModal/RenderAddress";
import useFetch from "../../../../hooks/useFetch";
import { setParcelTerminalsOptions } from "../../../../redux/Actions/options_action";
import { orderTypeMount } from "../../../../helpers/OrdersFunctionsGlobal";

function OrderCreateModal({
  payment_types,
  avalaibleStatus,
  onClose,
  carriers,
}) {
  const { value: countryData } = useFetch("/api/v1/countries");
  const countries = countryData ? countryData.data : [];
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const [total_price, setTotalPrice] = useState(0);
  const [totals, setTotals] = useState({
    total_products: 0,
    total_shipping: 0,
  });

  useEffect(() => {
    const { total_products, total_shipping } = totals;
    const plusTotals = +total_products + +total_shipping;
    setTotalPrice(plusTotals);
  }, [totals]);

  useEffect(() => {
    dispatch(setParcelTerminalsOptions());
  }, []);

  const [collapse, setCollapse] = useState({
    general_info: true,
    general_goods: true,
    general_goods_add: true,
    general_delivery: true,
    general_status: true,
  });

  const findCarrierDefault = () => {
    const findCarrier = carriers.find(
      (e) => e.label == "DPD kurjeris" || e.module_name == "technocarrier"
    );
    if (findCarrier) {
      return findCarrier.id;
    }
    return undefined;
  };

  const [loading, setLoading] = useState(false);
  const [general, setGeneral] = useState({
    payment: undefined,
    status_id: null,
    rline: false,
    rline_code: "",
    consultant: false,
    consultant_code: user.tabel_number,
    consultant_email: user.email,
    carrier_id: findCarrierDefault(),
    order_shop_id: null,
    // carrier_id: undefined,
  });

  const [shippingAddress, setShippingAddress] = useState({
    firstname: "",
    lastname: "",
    street: "",
    city: "",
    postal_code: "",
    phone: "",
    parcel_terminal_id: null,
    other: "",
  });
  const [billingAddress, setBillingAddress] = useState({
    firstname: "",
    lastname: "",
    street: "",
    city: "",
    postal_code: "",
    phone: "",
    other: "",
    company: "",
    company_code: "",
    vat_code: "",
  });

  const [orderRows, setOrderRows] = useState([]);

  const [errors, setErrors] = useState({});

  // State End

  const onHandleChangeAddress = (e, full, updateNext) => {
    if (full) {
      if (full === "billingAddress") {
        if (!general.carrier_id || updateNext) {
          setShippingAddress((prev) => ({
            ...prev,
            ...e,
          }));
        }
        return setBillingAddress((prev) => ({
          ...prev,
          ...e,
        }));
      } else {
        return setShippingAddress((prev) => ({
          ...prev,
          ...e,
        }));
      }
    }
    let { value, name } = e.target;

    if (name.startsWith("[billingAddress]")) {
      name = name.split("[billingAddress]")[1];
      setBillingAddress((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (
        !shippingAddress[name] ||
        shippingAddress[name] == "" ||
        shippingAddress[name] == billingAddress[name]
      ) {
        return setShippingAddress((prev) => ({
          ...prev,
          [name]: value,
        }));
      } else {
        return;
      }
    } else {
      name = name.split("[shippingAddress]")[1];
      return setShippingAddress((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onChangeGeneral = (e, massUpdate) =>
    massUpdate
      ? setGeneral({ ...general, ...e })
      : setGeneral({ ...general, [e.target.name]: e.target.value });

  const onChangeTotals = (e) =>
    setTotals({ ...totals, [e.target.name]: e.target.value });

  const onChangeOrderRows = (arr) => setOrderRows(arr);

  const collapseBlock = (name) =>
    setCollapse({ ...collapse, [name]: !collapse[name] });

  const validationsOnSubmitForm = () => {
    let errors = {};
    let collapse = {};
    const { status_id, payment, carrier_id, order_shop_id } = general;
    const {
      phone: ship_phone,
      country_id: ship_country,
      parcel_terminal_id,
      firstname: shippingAddressFirstname,
      lastname: shippingAddressLastname,
      street: shippingAddressStreet,
      city: shippingAddressCity,
      postal_code: shippingAddressPostalCode,
      other: shippingAddressEmail,
    } = shippingAddress;
    const {
      phone: bill_phone,
      other: email,
      firstname,
      lastname,
      company,
      company_code,
      country_id,
      street,
      city,
      postal_code,
    } = billingAddress;

    if (!carrier_id) {
      errors.carrier = "Fill in the field";
      collapse.general_delivery = true;
    } else {
      const c_carrier = carriers.find((e) => e.id == carrier_id);
      const { delivery } = orderTypeMount(c_carrier, parcel_terminal_id);
      if (delivery.includes("_postMachine") && !parcel_terminal_id) {
        errors.parcel_terminal_id = "Fill in the field";
        collapse.general_delivery = true;
      }
    }

    if (!order_shop_id) {
      errors.order_shop_id = "Fill in the field";
      collapse.general_delivery = true;
    }
    if (!payment) {
      errors.payment = "Fill in the field";
      collapse.general_delivery = true;
    }
    if (!status_id) {
      errors.status = "Fill in the field";
      collapse.general_status = true;
    }
    if (!phonenumberValid(ship_phone)) {
      errors["shipping_address.phone"] = ["Check the number"];
      collapse.general_info = true;
    }
    if (!phonenumberValid(bill_phone)) {
      errors["billing_address.phone"] = ["Check the number"];
      collapse.general_info = true;
    }
    if (!street) {
      errors["billing_address.street"] = ["Fill in Address"];
      collapse.general_info = true;
    }
    if (!city) {
      errors["billing_address.city"] = ["Fill in City"];
      collapse.general_info = true;
    }
    if (!postal_code) {
      errors["billing_address.postal_code"] = ["Fill in Postal Code"];
      collapse.general_info = true;
    }
    if (!shippingAddressFirstname) {
      errors["shippingAddress.firstname"] = ["Fill in First name"];
      collapse.general_info = true;
    }
    if (!shippingAddressLastname) {
      errors["shippingAddress.lastname"] = ["Fill in Last name"];
      collapse.general_info = true;
    }
    if (!carrier_id) {
      if (!shippingAddressStreet) {
        errors["shippingAddress.street"] = ["Fill in Address"];
        collapse.general_info = true;
      }
      if (!shippingAddressCity) {
        errors["shippingAddress.city"] = ["Fill in City"];
        collapse.general_info = true;
      }
      if (!shippingAddressPostalCode) {
        errors["shippingAddress.postal_code"] = ["Fill in Postal Code"];
        collapse.general_info = true;
      }
    }

    if (!shippingAddressEmail) {
      errors["shippingAddress.email"] = ["Fill in Email"];
      collapse.general_info = true;
    }
    if (!ship_country) {
      errors["shipping_address.country_id"] = "Select country";
      collapse.general_info = true;
    }
    if (!country_id) {
      errors["billing_address.country_id"] = "Select country";
      collapse.general_info = true;
    }
    if (!firstname || firstname.length < 2) {
      errors["billing_address.firstname"] = [
        "Fill in the field, min 3 characters",
      ];
      collapse.general_info = true;
    }
    if (!lastname || lastname.length < 3) {
      errors["billing_address.lastname"] = [
        "Fill in the field, min 3 characters",
      ];
      collapse.general_info = true;
    }
    if (company && !company_code) {
      errors["billing_address.company_code"] = ["Fill in the field"];
      collapse.general_info = true;
    }

    if (!email || !validateEmail(email)) {
      errors["billing_address.email"] = ["Badly entered email mail"];
      collapse.general_info = true;
    }

    return { errors, collapse };
  };

  const onSubmitForm = async () => {
    try {
      setLoading(true);
      const { errors, collapse: collapseFFunc } = validationsOnSubmitForm();
      console.log("Errors: ", errors);
      if (Object.entries(errors).length > 0) {
        setCollapse({ ...collapse, ...collapseFFunc });
        unsuccessToast("order-e");

        return setErrors(errors);
      }
      setErrors({});

      let billing_address_attributes = {
        ...billingAddress,
        customer_id: null,
      };
      let shipping_address_attributes = {
        ...shippingAddress,
        customer_id: null,
      };

      if (shipping_address_attributes.parcel_terminal_id) {
        if (!shipping_address_attributes.street || shipping_address_attributes.street === "") {
          shipping_address_attributes.street = billing_address_attributes.street;
        }
        if (!shipping_address_attributes.city || shipping_address_attributes.city === "") {
          shipping_address_attributes.city = billing_address_attributes.city;
        }
        if (!shipping_address_attributes.postal_code || shipping_address_attributes.postal_code === "") {
          shipping_address_attributes.postal_code = billing_address_attributes.postal_code;
        }
      }

      delete billing_address_attributes.key;
      delete billing_address_attributes.value;
      delete billing_address_attributes.children;
      delete billing_address_attributes.label;
      delete shipping_address_attributes.key;
      delete shipping_address_attributes.value;
      delete shipping_address_attributes.children;
      delete shipping_address_attributes.label;
      // id pasalint ir kurti naujsu juos

      const {
        status_id,
        payment,
        order_shop_id,
        carrier_id,
        rline_code,
        rline,
        consultant,
        consultant_code,
        consultant_email,
      } = general;
      const { total_products, total_shipping } = totals;
      const params = {
        order: {
          created: "užsakymai",
          order_shop_id,
          billing_address_attributes,
          shipping_address_attributes,
          customer_attributes: {
            firstname: billingAddress.firstname,
            lastname: billingAddress.lastname,
            company_code: billingAddress.company_code || null,
            consultant_code: consultant ? consultant_code : "",
            email: consultant
              ? consultant_email
              : billingAddress.other
                ? billingAddress.other
                : "",
            rline: rline ? 1 : 0,
            rline_code: rline ? rline_code : "",
          },
          order_rows_attributes: orderRows,
          id_order: null,
          carrier_id,
          order_date: new Date(),
          payment: payment || null,
          payment_module:
            payment_types.find((e) => e.value == payment)?.module_name || null,
          status_id: status_id || null,
          order_histories_attributes: [
            {
              title: "User",
              status_id,
              datetime: new Date(),
            },
          ],
          // Totals
          total_discounts: 0,
          total_discounts_tax_incl: 0,
          total_discounts_tax_excl: 0,
          total_products:
            Number(
              total_products - getFromPercentage(21, total_products)
            ).toFixed(2) || 0,
          total_products_wt: total_products || 0,
          // cia atsiemimas 1.5
          total_shipping: total_shipping || 0,
          total_shipping_tax_incl: total_shipping || 0,
          total_shipping_tax_excl: total_shipping || 0,
          total_price,
          total_paid: 0,
          total_paid_tax_incl: 0,
          total_paid_tax_excl: 0,
          total_paid_real: 0,
          // total_paid_tax_excl
        },
      };

      const data = await dispatch(createOrder(params));
      if (data.success) {
        onClose();
      } else {
        setErrors(data.errors);
      }
    } catch (err) {
      console.log("Error:", err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div
      className="d-flex flex-column justify-content-between"
      style={{ minHeight: "100%" }}
    >
      <div className="row">
        <div className="col-12 col-lg-6">
          <Divs className="container-title-block">
            <MainBlock
              color={"#ffa800"}
              action={collapse.general_info}
              onChange={() => collapseBlock("general_info")}
            >
              Order information
            </MainBlock>
          </Divs>
          {collapse.general_info && (
            <Fragment>
              <RenderAddress
                carriers={carriers}
                onChange={onHandleChangeAddress}
                shippingAddress={shippingAddress}
                billingAddress={billingAddress}
                errors={errors}
                general={general}
                countries={countries}
              />

              <Divs className="p-4">
                <OrderTotalComponent
                  order_id={""}
                  total_price={total_price}
                  payments={[]}
                />
              </Divs>
              <MainBlock
                color={"#ffcc69"}
                action={collapse.general_goods}
                onChange={() => collapseBlock("general_goods")}
              >
                Goods
              </MainBlock>
              {collapse.general_goods && (
                <RenderGoods
                  onChangeOrderRows={onChangeOrderRows}
                  onChangeTotals={onChangeTotals}
                  order_rows={orderRows}
                  setOrderRows={setOrderRows}
                  order_shop_id={general.order_shop_id}
                />
              )}
            </Fragment>
          )}
        </div>
        <div className="col-12 col-lg-6">
          <MainBlock
            color={"#00aaa0"}
            action={collapse.general_delivery}
            onChange={() => collapseBlock("general_delivery")}
          >
            Delivery
          </MainBlock>
          {collapse.general_delivery && (
            <Divs className="bg-silver mb-4 py-3">
              <RenderDelivery
                onHandleChangeAddress={onHandleChangeAddress}
                carriers={carriers}
                general={general}
                onChange={onChangeGeneral}
                payment_types={payment_types}
                total_shipping={totals.total_shipping}
                onChangeTotals={onChangeTotals}
                errors={errors}
                shipping_address={shippingAddress}
              />
            </Divs>
          )}
          <MainBlock
            color={"#adcb35"}
            action={collapse.general_status}
            onChange={() => collapseBlock("general_status")}
          >
            Status
          </MainBlock>
          {collapse.general_status && (
            <Divs className="py-4 bg-silver">
              <RenderStatus
                order_shop_id={general.order_shop_id}
                avalaibleStatus={
                  !general.order_shop_id
                    ? []
                    : avalaibleStatus.filter(
                      (e) =>
                        e.shop_id == general.order_shop_id && !e.technorama
                    )
                }
                status_id={general.status_id}
                onChange={onChangeGeneral}
                errors={errors}
              />
            </Divs>
          )}
        </div>
      </div>

      <div>
        <button
          disabled={loading}
          type="button"
          className="btn btn-primary mt-3 float-right"
          style={{ width: "50%" }}
          onClick={() => onSubmitForm()}
        >
          {loading ? "Loading..." : "Submit"}
        </button>
      </div>
    </div>
  );
}

export default OrderCreateModal;

// Componetai
const RenderGoods = ({
  onChangeOrderRows,
  onChangeTotals,
  order_rows,
  setOrderRows,
  order_shop_id,
}) => {
  const postOrderRowGoods = async (object) => {
    try {
      const rows = [...order_rows, object.order_row];
      let promise = new Promise((resolve) => {
        onChangeOrderRows(rows);
        const reduxProducts = rows.reduce(
          (cur, acc) => +acc.product_price * +acc.quantity + cur,
          0
        );
        onChangeTotals({
          target: { name: "total_products", value: reduxProducts },
        });
        return resolve({ ok: true });
      });

      const result = await promise;
      return result;
    } catch (err) { }
  };
  const deleteOrderRow = (idx) => {
    const rows = [...order_rows];
    rows.splice(idx, 1);
    const reduxProducts = rows.reduce(
      (cur, acc) => +acc.product_price * +acc.quantity + cur,
      0
    );
    onChangeTotals({
      target: { name: "total_products", value: reduxProducts },
    });
    onChangeOrderRows(rows);
  };

  const updateOrderRow = (idx, newObj) => {
    const oldOrderRows = [...order_rows];
    oldOrderRows[idx] = {
      ...oldOrderRows[idx],
      ...newObj,
      manual: false,
    };
    const reduxProducts = oldOrderRows.reduce(
      (cur, acc) => +acc.product_price * +acc.quantity + cur,
      0
    );
    onChangeTotals({
      target: { name: "total_products", value: reduxProducts },
    });
    setOrderRows(oldOrderRows);
  };
  return (
    <div className="bg-silver py-3 m-0">
      <React.Fragment>
        <Divs>
          <div className="table-responsive bg-silver">
            <div
              className="col-12"
              style={{
                marginBottom: "1rem",
              }}
            >
              <table
                className="table table-sm"
                style={{ marginBottom: "0px!important" }}
              >
                {/*  */}
                {order_rows.map((item, idx) => (
                  <OrderRow
                    key={idx}
                    item={item}
                    updateOrderRow={(item) => updateOrderRow(idx, item)}
                    deleteOrderRow={() => deleteOrderRow(idx)}
                  />
                ))}
                {/*  */}
              </table>
            </div>
          </div>
        </Divs>
        <OrderRowAdd
          mode={"Order_create"}
          orderId={""}
          postOrderRowGoods={postOrderRowGoods}
          order_shop_id={order_shop_id}
        />
      </React.Fragment>
    </div>
  );
};

function OrderRow({ item, updateOrderRow, deleteOrderRow }) {
  const [showRemove, setShowRemove] = useState(false);
  const [update, setUpdate] = useState(false);
  const [errors, setErrors] = useState({});
  const [variables, setVariables] = useState({
    product_name: item.product_name,
    quantity: item.quantity,
    product_price: item.product_price,
  });

  const onChange = (e) =>
    setVariables({ ...variables, [e.target.name]: e.target.value });
  const updateFunc = () => {
    if (update) {
      const { product_name, quantity, product_price } = variables;
      if (product_name && quantity && product_price) {
        setUpdate(false);
        updateOrderRow(variables);
      } else {
        let errors = {};
        if (!product_name) {
          errors.product_name = "Enter the text";
        }
        if (!quantity) {
          errors.quantity = "Enter the amount";
        }
        if (!product_price) {
          errors.product_price = "Enter the price";
        }
        return setErrors(errors);
      }
    } else {
      setUpdate(true);
      setVariables({
        product_name: item.product_name,
        quantity: item.quantity,
        product_price: item.product_price,
      });
    }
  };
  return (
    <thead
      onMouseEnter={() => setShowRemove(true)}
      onMouseLeave={() => setShowRemove(false)}
    >
      <tr>
        <td className="align-middle" style={{ fontSize: "0.8rem" }}>
          {["{}", "", null].includes(item.product_reference) ? (
            <div className="text-center m-auto">
              <AiOutlineCheckCircle className="text-success mr-1" />
            </div>
          ) : (
            item.product_reference
          )}
        </td>
        <td className="align-middle" colSpan="4">
          {update ? (
            <span className="d-flex">
              <div style={{ maxWidth: 100 }}>
                <TextInputModal
                  type="number"
                  name="quantity"
                  value={variables.quantity}
                  onChange={onChange}
                  warning={errors.quantity}
                />
              </div>
              <div>
                <TextInputModal
                  name="product_name"
                  value={variables.product_name}
                  onChange={onChange}
                  warning={errors.product_name}
                />
              </div>
            </span>
          ) : (
            <span style={{ fontSize: "0.8rem" }}>
              {parseInt(item.quantity)}
              &nbsp;*&nbsp;
              <span
                className={item.manual ? "border-bottom border-danger" : null}
              >
                {item.product_name}
              </span>
            </span>
          )}
        </td>
        <td className="align-middle">{item.barcode}</td>
        <td
          className="align-middle"
          style={{
            float: "right",
            fontSize: "0.8rem",
          }}
        >
          {update ? (
            <TextInputModal
              type="number"
              name="product_price"
              value={variables.product_price}
              onChange={onChange}
              warning={errors.product_price}
            />
          ) : (
            <span className="d-flex">
              <span>{Number(item.product_price).toFixed(2) || 0}</span>
              <span> &#8364;</span>
            </span>
          )}
        </td>
        <td
          className="align-middle text-right"
          style={{ whiteSpace: "nowrap" }}
        >
          {update ? (
            <Fragment>
              <FaCheck
                className="text-success"
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={updateFunc}
              />
              <FaTimes
                className="text-danger"
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  setUpdate(false);
                  setErrors({});
                }}
              />
            </Fragment>
          ) : (
            <Fragment>
              <MdEdit
                className="text-warning"
                style={{
                  cursor: "pointer",
                  visibility: showRemove ? "visible" : "hidden",
                  marginLeft: "10px",
                }}
                onClick={updateFunc}
              />
              <FaTrash
                className="text-danger"
                style={{
                  cursor: "pointer",
                  visibility: showRemove ? "visible" : "hidden",
                  marginLeft: "10px",
                }}
                onClick={deleteOrderRow}
              />
            </Fragment>
          )}
        </td>
      </tr>
    </thead>
  );
}
